import { render, staticRenderFns } from "./Taxrules.vue?vue&type=template&id=405af972"
import script from "./Taxrules.vue?vue&type=script&lang=js"
export * from "./Taxrules.vue?vue&type=script&lang=js"
import style0 from "./Taxrules.vue?vue&type=style&index=0&id=405af972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports